import React from "react";
import { Outlet, useLoaderData } from "react-router-dom";
import TabLayout from "../../../helpers/TabLayout";

const EmailLayout = () => {
  const { userEmail } = useLoaderData();
  return (
    <>
      <TabLayout
        headerLabel={userEmail.email}
        skeletonLines={14}
      >
        <Outlet/>
      </TabLayout>
    </>
  );
};

export default EmailLayout;